import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../../../components/Common/SectionTitle";
import QuickLinks from "../../../components/Common/QuickLinks";
import ScrollToTop from "../../../components/Common/ScrollTop";
import { fetchData, imageBaseURL } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
import SliderDefault from "../../../components/Slider/SliderDefault";
import { BlocksRenderer } from "../../../components/BlockRenderer";

const HomeMain = ({ currentDomain }) => {
  const [data, setData] = useState([]);
  const [profileData, SetProfileData] = useState(null);
  const [profileData2, setProfileData2] = useState(null);
  useEffect(() => {
    console.log("this is home.......");
    fetchData(getAPIPath()?.home, setData);
    fetchData(getAPIPath()?.profile, SetProfileData);
    if (currentDomain === "snt") {
      fetchData(getAPIPath()?.profile2, setProfileData2);
    }
  }, []);

  return (
    <React.Fragment>
      <SliderDefault />
      {getMenu()}

      <div id="rs-about" className="rs-about style1 pt-50 pb-50 md-pt-30">
        <div className="container">
          <div className="row">
            <div className="col md-mb-30">
              <div className="content-wrapper">
                <div className="content-section">
                  <div className="row flex-column flex-md-row">
                    <div className="col-lg-4 md-mb-30" style={{width: '290px'}}>
                      <div className="img-part">
                        <img
                          className="about-main w-100"
                          src={
                            imageBaseURL +
                            profileData?.data[0]?.attributes?.Image?.data
                              ?.attributes?.url
                          }
                          alt={profileData?.data[0]?.attributes?.Name}
                          title={profileData?.data[0]?.attributes?.Name}
                        />
                        <div className="info-part mt-14">
                          <h2
                            className="white"
                            title={profileData?.data[0]?.attributes?.Name}
                          >
                            {profileData?.data[0]?.attributes?.Name}
                          </h2>
                          <div className="exInfo white">
                            {profileData?.data[0]?.attributes?.Designation}
                          </div>
                          <div className="exInfo white">{getPageTitle()}</div>
                        </div>
                      </div>

                      <div style={{ marginTop: "10px" }}>
                        <Link
                          to={{
                            pathname: `/${currentDomain}/profile`,
                            state: {
                              data: profileData?.data[0],
                            },
                          }}
                        >
                          View Profile
                        </Link>
                      </div>

                      {currentDomain === "snt" && profileData2 !== null && (
                        <>
                          <div
                            className="img-part"
                            style={{ marginTop: "30px" }}
                          >
                            <img
                              className="about-main w-100"
                              src={
                                imageBaseURL +
                                profileData2?.data[0]?.attributes?.Image?.data
                                  ?.attributes?.url
                              }
                              alt={profileData2?.data[0]?.attributes?.Name}
                              title={profileData2?.data[0]?.attributes?.Name}
                            />
                            <div className="info-part mt-14">
                              <h2
                                className="white"
                                title={profileData2?.data[0]?.attributes?.Name}
                              >
                                {profileData2?.data[0]?.attributes?.Name}
                              </h2>
                              <div className="exInfo white">
                                {profileData2?.data[0]?.attributes?.Designation}
                              </div>
                              <div className="exInfo white">
                                {getPageTitle()}
                              </div>
                            </div>
                          </div>
                          <div style={{ marginTop: "10px" }}>
                            <Link
                              to={{
                                pathname: `/${currentDomain}/profile`,
                                state: {
                                  data: profileData2?.data[0],
                                },
                              }}
                            >
                              View Profile
                            </Link>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="col">
                      <div className="about-content">
                        {/* Section Title Start */}
                        {currentDomain !== "shsr" ? (
                          <>
                            <h2
                              style={{ marginBottom: "20px" }}
                              title={data?.data?.attributes?.Page_Heading}
                            >
                              {data?.data?.attributes?.Page_Heading}
                            </h2>
                            <BlocksRenderer
                              content={data?.data?.attributes?.Body || []}
                            />
                          </>
                        ) : (
                          <>
                            <SectionTitle
                              sectionClass="sec-title"
                              subtitleClass="sub-title secondary text-capitalize"
                              subtitle={data?.data?.attributes?.Page_Heading}
                              titleClass=""
                              title=""
                              descClass="desc mb-10"
                              description={
                                data?.data?.attributes?.Body.slice(0, 2) || []
                              }
                              secondDescClass="desc"
                            />
                            <div className="text-end mt-10">
                              <Link
                                className="readon orange-btn main-home text-capitalize"
                                to={`/${currentDomain}/about-us`}
                              >
                                See more
                              </Link>
                            </div>
                          </>
                        )}

                        {/* Section Title End */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {showQuickLinks(currentDomain) && (
              <div className="col-lg-3 pl-20 md-pl-14">
                <div className="about-intro">
                  <QuickLinks />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ScrollToTop scrollClassName="scrollup secondaryColor" />
    </React.Fragment>
  );
};
export default HomeMain;
const showQuickLinks = (currentDomain) => {
  if (currentDomain === "shsr") return true;
  else if (currentDomain === "ssit") return true;
  else return false;
};
